import * as Sentry from "@sentry/vue";

import type { WelcomeVariant } from "./types/WelcomeFlowTypes";

/**
 * A Frontegg account created before the release date is "existing"; created at or after it is
 * "new". Frontegg types `user.createdAt` as `Date`, but the runtime value from the `/me` response
 * is an ISO string — always parse with `new Date(...)` rather than trusting the type.
 *
 * Missing or unparseable defaults to "existing" (the safe majority at release) and reports to
 * Sentry so an unreliable field is visible rather than silently mis-splitting users.
 */
export function resolveWelcomeVariant(createdAt: Date | string | undefined | null, releaseDate: Date): WelcomeVariant {
  const parsed = createdAt ? new Date(createdAt) : null;

  if (!parsed || Number.isNaN(parsed.getTime())) {
    Sentry.captureMessage("Welcome flow: user.createdAt missing, defaulting to existing");
    return "existing";
  }

  return parsed.getTime() < releaseDate.getTime() ? "existing" : "new";
}
